import { request } from './client'

export async function getVapidKey(): Promise<{ vapidPublicKey: string }> {
  return request('/push_subscriptions/vapid_key')
}

export async function subscribeToPush(subscription: {
  endpoint: string
  p256dh: string
  auth: string
}): Promise<{ id: number }> {
  return request('/push_subscriptions', {
    method: 'POST',
    body: subscription,
  })
}

export async function unsubscribeFromPush(endpoint: string): Promise<void> {
  await request<void>('/push_subscriptions', {
    method: 'DELETE',
    body: { endpoint },
  })
}
